import type { SearchMLModelsRequest, SearchRegisteredModelsRequest } from '@/entities/registered-model';

export const registeredModelKeys = {
  all: ['registeredModel'] as const,

  registeredModelsListPrefix: () => [...registeredModelKeys.all, 'list'] as const,
  registeredModelsList: (params: SearchRegisteredModelsRequest) =>
    [...registeredModelKeys.registeredModelsListPrefix(), params] as const,

  mlModelsListPrefix: () => [...registeredModelKeys.all, 'mlModelsList'] as const,
  mlModelsList: (params: SearchMLModelsRequest) => [...registeredModelKeys.mlModelsListPrefix(), params] as const,

  mlflowList: () => [...registeredModelKeys.all, 'mlflowList'] as const,

  registeredModelDetailPrefix: () => [...registeredModelKeys.all, 'detail'] as const,
  registeredModelDetail: (modelName: string) =>
    [...registeredModelKeys.registeredModelDetailPrefix(), modelName] as const,
} as const;
